/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { findBookings, sortBookings, getBooking, printBookingsData, getBookingSelectItems } from '../../reducers/VfcReducer';
import DataTable from '../../components/DataTable';
import Report from './BookingReport';
import Paper from '@material-ui/core/Paper';
import FiltersPanel from '../../components/FiltersPanel';
import bookingsConfig from '../../config/booking-data-table.json';
import filtersConfig from '../../config/booking-data-search-filters.json';
import PrintData from '../../components/PrintData';
import PrintIcon from '@material-ui/icons/Print';
import appConfig from '../../config/appConfig.json';

const useStyles = makeStyles(theme => ({
  page: {
    boxSizing: 'border-box'
  },
  searchBar: {
    padding: '30px 20px 30px',
    '& > h3': {
      color: '999',
      paddingLeft: 10,
    },
    '& > h4': {
      color: '#999',
      fontSize: 20
    },
  },
  tabs: {
    marginBottom: 30,
  },
  action: {
    textAlign: 'right',
    padding: '1em 0',
    '& button': {
      marginLeft: 10,
      '&:first-child': {
        marginLeft: 0,
      }
    }
  }
}));

function ReportList(props) {
  const classes = useStyles();
  const { bookings, bookingDetails, printData, bookingSelectItems } = props.vfc;
  const { loading, loaded, rows, error } = bookings;
  const webSocket = props.webSocket;  
  const [selected, setSelected] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (bookingDetails.data && selected) setShowDetails(true);
  }, [bookingDetails]);

  const getBookingSelectItems = () => {
    //console.log("p2:", Date.now());
    props.getBookingSelectItems();
  }
  useEffect(() => {  
    //console.log("p1:", Date.now(), webSocket);
    if(webSocket)
      getBookingSelectItems();
    
  }, [loaded, loading, webSocket]);

  const getData = options => {
    props.findBookings(options);
  };

  const sort = name => {
    props.sortBookings(name);
  };

  const selectRow = row => {
    setSelected(row);
  };

  const getReport = () => {        
    props.getBooking(selected.vfcMainId);//CaseNumber
  };

  const closeDetails = () => {
    setShowDetails(false);
  };

  const tableDblClick = () => {    
    getReport();
  }

  const printList = () => {
    const msg = `The result array exceeds the maximum number of ${appConfig.maxPrintResults} rows.\n` +
    `Continue printing first ${appConfig.maxPrintResults} rows?`;
    if (bookings.count > appConfig.maxPrintResults && !window.confirm(msg) ) return;
    props.printBookingsData();
  }

  return (
    <div className={classes.page}>
      <Paper square className={classes.searchBar}>
        <h3>Archive Browser-Booking Data</h3>
        { bookingSelectItems && ( <FiltersPanel getData={getData} config={filtersConfig} data={bookings} selectItems={bookingSelectItems}/> ) }
        {rows.length > 0 && (
          <Fragment>
            <h4>Search Results</h4>
            <div className={classes.action}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                onClick={printList}
                startIcon={<PrintIcon />}>
                Print List
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                onClick={getReport}
                startIcon={<AssignmentIcon />}
                disabled={!selected}>
                Show Details
              </Button>
            </div>
            <DataTable
              getData={getData}
              data={bookings}
              config={bookingsConfig}
              sort={sort}
              selectRow={selectRow}
              dblClick={tableDblClick}
            />
          </Fragment>
        )}
        {loading && rows.length === 0 && <LoadingData />}
        {!loaded && !loading  && rows.length === 0 && <StartSearching />}
        {loaded && !loading  && rows.length === 0 && !error && <NoResults />}
        {loaded && !loading  && rows.length === 0 && error && <ErrorLoading />}
        {showDetails && <Report data={bookingDetails.data} close={closeDetails} />}
      </Paper>
      {printData && <PrintData config={bookingsConfig}/>}
    </div>
  );
}

function NoResults() {
  return <h4>Sorry, no results match your search criteria.</h4>;
}

function LoadingData() {
  return <h4>Loading the data, plase wait...</h4>;
}

function StartSearching() {
  return <h4>Please define your search criteria.</h4>;
}

function ErrorLoading() {
  return <h4>There was an error while recieving the data.</h4>;
}

const mapStateToProps = state => {
  return {
    vfc: state.vfc,
    webSocket: state.websocket.websocket
  };
};

export default connect(mapStateToProps, {
  findBookings,
  sortBookings,
  getBooking,
  printBookingsData,
  getBookingSelectItems,
})(ReportList);
